import {
  FETCH_SCREENS_REQUEST,
  FETCH_SCREENS_SUCCESS,
  FETCH_SCREENS_FAILURE,
  FETCH_SCREEN_REPORT_REQUEST,
  FETCH_SCREEN_REPORT_SUCCESS,
  FETCH_SCREEN_REPORT_FAILURE,
} from "./actionTypes";
import { initialState } from "./initialState";

const screenReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SCREENS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_SCREENS_SUCCESS:
      return { ...state, loading: false, screens: action.payload };

    case FETCH_SCREENS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FETCH_SCREEN_REPORT_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_SCREEN_REPORT_SUCCESS:
      return { ...state, loading: false, screenReport: action.payload };

    case FETCH_SCREEN_REPORT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default screenReducer;
